import './ActivitySelectionMenu.css';

export interface ActivityItem {
  id: string;
  nombreActividad: string;
  nivel: string;
  objetivo: string;
  metodoActividad: string;
  vocabulario: string;
  grupo: string;
}

interface ActivitySelectionMenuProps {
  activities: ActivityItem[];
  isLoading: boolean;
  errorMessage: string | null;
  onSelect: (activity: ActivityItem) => void;
  onComplete: (activity: ActivityItem) => void;
  onClose: () => void;
  currentActivityId: string | null;
  completedActivityIds: Set<string>;
}

export function ActivitySelectionMenu({
  activities,
  isLoading,
  errorMessage,
  onSelect,
  onComplete,
  onClose,
  currentActivityId,
  completedActivityIds,
}: ActivitySelectionMenuProps) {
  return (
    <div className="activity-menu">
      <div className="activity-menu-content">
        <header className="activity-menu-header">
          <h2>Available activities</h2>
          <button className="activity-menu-close" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </header>

        {isLoading && <p className="activity-menu-status">Loading available activities...</p>}
        {errorMessage && !isLoading && (
          <p className="activity-menu-status error">{errorMessage}</p>
        )}

        {!isLoading && !errorMessage && activities.length === 0 && (
          <p className="activity-menu-status">No activities available yet.</p>
        )}

        {!isLoading && !errorMessage && activities.length > 0 && (
          <div className="activity-menu-list">
            {activities.map((activity) => {
              const isCompleted = completedActivityIds.has(activity.id);
              const isCurrent = activity.id === currentActivityId && !isCompleted;

              return (
                <div
                  key={activity.id}
                  className={`activity-card-row ${isCurrent ? 'is-current' : ''}`}
                  onClick={() => {
                    if (isCurrent) {
                      onComplete(activity);
                    } else if (!isCompleted) {
                      onSelect(activity);
                    }
                  }}
                >
                  <div className={`activity-card ${isCurrent ? 'current' : ''} ${isCompleted ? 'done' : ''}`}>
                    <div className="activity-card-info">
                      <div className="activity-card-title">{activity.nombreActividad}</div>
                      <div className="activity-card-meta">
                        <span>{activity.nivel || 'Nivel'}</span>
                        <span>{activity.grupo || 'General'}</span>
                      </div>
                      {isCurrent && (
                        <div className="activity-card-hint">Tap here to mark as completed</div>
                      )}
                    </div>

                    <div className="activity-card-status">
                      {isCompleted && (
                        <div className="activity-check-badge">
                          <img src="/assets/selection/check.png" alt="Completada" className="activity-check-icon" />
                        </div>
                      )}
                      {isCurrent && (
                        <div className="activity-circle-badge" />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
